import fetchWiremock from 'utilities/mock/fetchWiremock';
import { BasketAddItemOptions, BasketAmendItemOptions, BasketResponse } from 'types/BasketTypes';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import adaptBasketResponse from '../adaptors/adaptBasketResponse';

export default class MockBasketService implements BasketServiceInterface {
  async addItem({ item }: BasketAddItemOptions): Promise<BasketResponse> {
    const response = await fetchWiremock({
      method: 'POST',
      path: '/api/checkout/v1/basket/items',
      body: item,
    });

    const data = (await response.json()) as BasketResponse;

    return adaptBasketResponse({
      ...data,
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
    });
  }

  async amendItem({ lineItem, item }: BasketAmendItemOptions): Promise<BasketResponse> {
    const response = await fetchWiremock({
      method: 'PUT',
      path: `/api/checkout/v1/basket/items/${lineItem}`,
      body: item,
    });

    const data = (await response.json()) as BasketResponse;

    return adaptBasketResponse({
      ...data,
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
    });
  }
}
